import request from '../request/index';

export function getLocaterData() {
    const prefix = VITE_APP_MODE !== 'visitor' ? 'manage' : 'guest';
    return request
        .get(`/api/${prefix}/locater/getData`)
        .then(({ data }) => data);
}
